import React from 'react'
import { Box, Stack, Typography, Button } from '@mui/material'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

export default function Rhino8LaunchPromotion() {
  return (
    <Box py={{ xs: 4, md: 8 }} px={{ xs: 2, md: 4 }} bgcolor='#222'>
      <Stack
        data-gtm-click-subsection1='Rhino 8'
        data-gtm-component='banner'
        direction={{ xs: 'column', md: 'row' }}
        gap={4}
        alignItems='center'
        justifyContent='center'
      >
        <Box
          component='img'
          width={120}
          height={120}
          sx={{ border: '2px solid #505159', borderRadius: 6.5 }}
          alt='Rhino 8'
          src='https://meteor.stullercloud.com/das/125605632?fmt=smart-alpha&wid=120'
        />
        <Stack alignItems={{ xs: 'center', md: 'flex-start' }}>
          <Typography variant='h2'>
            Rhino<sup>®</sup> 8
          </Typography>
          <Typography mt={0.5}>
            <FormattedMessage id='rhino8LaunchPromotion.description' />
          </Typography>
          <Button
            data-gtm-click-subsection2='primary-cta'
            to='/store/rhinoceros/upgrade-to-rhino-8-from-older-versions'
            component={Link}
            variant='outlined'
            color='secondary'
            sx={{ mt: 2 }}
          >
            <FormattedMessage id='common.upgradeNow' />
          </Button>
        </Stack>
      </Stack>
    </Box>
  )
}
